<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="40%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: form.icon.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.icon"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createTag, updateTag } from '@/api/shop'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'TagEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken:null,
      form: {
        tagId:'',
        title: '',
        icon: [],
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        icon: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图标'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改标签'
        this.form = Object.assign(this.form, row.basic)
        this.form.icon = [{url:this.form.icon}]
        this.form.tagId = row.tagId
        this.form.title = row.title
      } else {
        this.title = '新增标签'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.icon = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.icon.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const tagId = this.form.tagId
          //处理数据 图片数组转string
          const data = Object.assign({},this.form)
          data.icon = data.icon[0].url
          this.$baseConfirm(
            `你确定要${tagId ? '修改' : '新增'}标签吗`,
            null,
            async () => {
              tagId
                ? await updateTag(data)
                : await createTag(data)
              this.$baseMessage(
                `${tagId ? '修改' : '新增'}标签成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
